import { Api } from './Api';

const  ENPOINTS = {
    EtatDemande: 'etat-demandes',
};

const getAll = signal => {
    return Api.get(ENPOINTS.EtatDemande, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.EtatDemande}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.EtatDemande, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.EtatDemande}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.EtatDemande}/${id}`, signal)
}

export const EtatDemandeService = {
    getAll,
    getById,
    create,
    update,
    destroy
}